import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './modal.css';

function ModalWindow(props) {
    const modalRef = useRef();
    const closeButtonRef = useRef();

    useEffect(() => {
        props.show ? document.addEventListener("mousedown", handleClick) :
            document.removeEventListener("mousedown", handleClick);

        return () => document.removeEventListener("mousedown", handleClick);
    }, [props]);

    const handleClick = (event) => {
        if (closeButtonRef.current === event.target || modalRef.current === event.target) {
            props.close();
        }
    };

    return(
        <>
            {
                props.show ?
                <div className="modalWindow" ref={ modalRef }>
                    <div className="modalWindow__content">
                        <div className="modalWindow__header" style={{ textAlign: props.textCenter ? 'center' : '' }}>
                            <span className="modalWindow__close_button" ref={ closeButtonRef } >&times;</span>
                            <h2 className="modalWindow__title">{ props.headerText }</h2>
                        </div>
        
                        <div className="modalWindow__body">
                            {props.children}
                        </div>
                    </div>
                </div>
                : null
            }
        </>
    );
};

ModalWindow.propTypes = {
    close: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    headerText: PropTypes.string.isRequired
};

export default ModalWindow;
